import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Box, useTheme } from "@mui/material";
import { TestimonialCard } from "@/components/TestimonialCard";
import { testimonials } from "./utils";

export function TestimonialsSwipper() {
  const theme = useTheme();

  return (
    <Box sx={{ width: "100%", position: "relative", paddingX: 7 }}>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={3}
        navigation
        pagination={{ clickable: true }}
        loop
        autoHeight={true}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        style={{ paddingBottom: "40px", width: "100%" }}
        breakpoints={{
          0: { slidesPerView: 1 },
          960: { slidesPerView: 2 },
          1200: { slidesPerView: 3 },
        }}
      >
        {testimonials.map((t) => (
          <SwiperSlide key={t.name}>
            <TestimonialCard {...t} />
          </SwiperSlide>
        ))}
      </Swiper>

      <style>{`
            .swiper-button-prev, .swiper-button-next {
              color: ${theme.palette.primary.main};
              top: 50%;
              width: 40px;
              height: 40px;
              margin-top: -20px;
              background: #fff;
              border-radius: 50%;
              box-shadow: 0 2px 10px rgba(0,0,0,0.1);
              z-index: 10;
            }
            .swiper-button-prev {
              left: 0;
              transform: translateX(-150%);
            }
            .swiper-button-next {
              right: 0;
              transform: translateX(150%);
            }
            .swiper-button-prev::after,
            .swiper-button-next::after {
              font-size: 20px;
            }
          `}</style>
    </Box>
  );
}
